const Constant = {
    API: "https://cms.nitrogengames.com/api/",
    REVALIDATE: 30,
  };
  
  export default Constant;
  
